import React from 'react';
import { CreditCard, Banknote, ArrowLeft, MapPin, Tag, X, Check, Gift, Store, Truck, Clock, Plus, ChevronRight, Trash2, Phone, CalendarDays } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Separator } from '../ui/separator';
import { formatPrice } from '../../lib/utils';
import StampCard from '../StampCard';

const PaymentMethodCard = ({
  paymentMethod,
  setPaymentMethod,
  t,
}) => (
  <>
              <Card className="bg-[#141417] border-[#27272A]">
                <CardHeader>
                  <CardTitle>{t('checkout.paymentMethod')}</CardTitle>
                </CardHeader>
                <CardContent>
                  <RadioGroup value={paymentMethod} onValueChange={setPaymentMethod}>
                    <Label htmlFor="cod" className={`flex items-center space-x-3 p-4 rounded-lg border cursor-pointer transition-colors ${paymentMethod === 'cod' ? 'border-[#FFC107]' : 'border-[#27272A] hover:border-[#FFC107]/50'}`}>
                      <RadioGroupItem value="cod" id="cod" data-testid="payment-cod" />
                      <div className="flex items-center gap-3 flex-1">
                        <Banknote className="h-5 w-5 text-[#FFC107]" />
                        <div>
                          <p className="font-medium">{t('checkout.cashOnDelivery')}</p>
                          <p className="text-sm text-zinc-400">{t('checkout.payOnReceive')}</p>
                        </div>
                      </div>
                    </Label>
                  </RadioGroup>
                </CardContent>
              </Card>
  </>
);

export default PaymentMethodCard;
